import React, {useState, useEffect} from 'react'

function ResendOtp({resendText="Resent", onClick=()=>{}}) {
    // resend timer
  const [timeLeft, setTimeLeft] = useState(0);
  const [targetTime, setTargetTime] = useState(0);

  // when the system is ready to allow a resend request
  const [activeResend, setActiveResend] = useState(false);

  let resendTimerInterval;

  const calculateTimeLeft = finalTime => {
    const difference = finalTime - +new Date();
    if (difference >= 0) {
      setTimeLeft(Math.round(difference / 1000));
    } else {
      setTimeLeft(0);
      clearInterval(resendTimerInterval);
      setActiveResend(true);
    }
  };

  const triggerTimer = (targetTimeInSecond = 10) => {
    onClick()
    setTargetTime(targetTimeInSecond);
    setActiveResend(false);
    const finalTime = +new Date() + targetTimeInSecond * 1000;
    resendTimerInterval = setInterval(() => {
      calculateTimeLeft(finalTime);
    }, 1000);
  };
  const triggerTimer1 = (targetTimeInSecond = 10) => {
    // onClick()
    setTargetTime(targetTimeInSecond);
    setActiveResend(false);
    const finalTime = +new Date() + targetTimeInSecond * 1000;
    resendTimerInterval = setInterval(() => {
      calculateTimeLeft(finalTime);
    }, 1000);
  };

  useEffect(() => {
    triggerTimer1();
    // onClick();

    return () => {
      clearInterval(resendTimerInterval);
    };
  }, []);
  return (
    <>
    <span>{!activeResend && (<div> in {timeLeft ? timeLeft : targetTime} second(s)</div>)}</span>
    {activeResend && <span onClick={()=>triggerTimer()}> <p>{resendText}</p></span>}
    
    </>
  )
}

export default ResendOtp